import React, { useLayoutEffect } from 'react';
import styles from './style.module.scss';
import { Card, Col, Row, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import useBreadcrumb from 'hooks/useBreadcrumb';
import Filters from 'components/filters';
import { Route, Routes } from 'react-router-dom';
import DeleteModal from 'components/deleteModalView';
import ViewModal from './viewModal';
import useShops from './useShops';
import Button from 'components/button';

const ShopsList = () => {
  const { t } = useTranslation();
  const { addNewBreadcrumb, removeLastBreadcrumb } = useBreadcrumb();
  const {
    filters,
    columns,
    data,
    loading,
    onChangeTableFilter,
    updateInProcess,
    onDelete,
    singleItem,
    handleDownloadExcel,
  } = useShops({ isMainPage: true });

  useLayoutEffect(() => {
    removeLastBreadcrumb('/profile/shops/list');
    addNewBreadcrumb(t('Anagrafica insegne'), '/profile/shops/list');
    return () => {
      removeLastBreadcrumb('/profile/shops/list');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card className={styles.card} title={t('Anagrafica insegne')}>
      <Row>
        <Col span={24}>
          <Filters hideClearAll filters={filters} />
        </Col>
        <Col span={24}>
          <Row gutter={16} align={'middle'}>
            <Col>
              <br />
              <Button onClick={handleDownloadExcel}>
                {t('Scarica excel')}
              </Button>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <br />
          <Table
            bordered
            dataSource={data?.shops}
            pagination={data?.pagination}
            onChange={onChangeTableFilter}
            columns={columns}
            scroll={{ x: 1500 }}
            loading={loading}
          />
        </Col>
      </Row>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal loading={updateInProcess} onClickDelete={onDelete} />
          }
        />
        <Route
          path={':id/view'}
          element={<ViewModal singleItem={singleItem} />}
        />
      </Routes>
    </Card>
  );
};

export default ShopsList;
